/**
 *   Generated file. Do not edit
 */
import './converter-stream-extension';

import { BodyConverter } from '@iotize/tap/client/api';

import { FirmwareState } from './models';
import { FirmwareUpdateResult } from './models';
import { CrcCheckBody } from './models';
import { TapStreamReader } from '@iotize/tap/client/impl';
import { TapStreamWriter } from '@iotize/tap/client/impl';
import { FixedSizeEnumConverter } from '@iotize/tap/client/impl';
import { enumKeyOrValueToNumber } from '@iotize/tap/client/impl';

export class CrcCheckBodyConverter implements BodyConverter<CrcCheckBody> {
  public encode(
    model: CrcCheckBody,
    stream: TapStreamWriter = new TapStreamWriter(),
  ): Uint8Array {
    stream.writeCrcCheckBody(model);
    return stream.toBytes;
  }

  public decode(data: TapStreamReader | Uint8Array): CrcCheckBody {
    const stream =
      data instanceof TapStreamReader ? data : TapStreamReader.create(data);
    return stream.readCrcCheckBody();
  }
}
